import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { CreateDarkWebStreamParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListStreams } from "../queries/useListStreams";

export const CreateDarkWebStream = graphql(/* GraphQL */ `
	mutation CreateDarkWebStream($params: CreateDarkWebStreamParams!) {
		createDarkWebStream(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useCreateDarkWebStream() {
	const [createDarkWebStream] = useMutation(CreateDarkWebStream, {
		refetchQueries: [ListStreams, "ListStreams"],
	});

	const handleCreateDarkWebStream = useCallback(
		async (params: CreateDarkWebStreamParams) => {
			const result = await createDarkWebStream({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.createDarkWebStream.success,
				error: result.data?.createDarkWebStream.error,
			};
		},
		[createDarkWebStream]
	);

	return { handleCreateDarkWebStream };
}
